const EXPRESSION_CHARS = /[+\-*/()]/;

function normalizeDecimal(raw) {
  return String(raw).trim().replace(/,/g, '.');
}

export function looksLikeExpression(raw) {
  if (raw === '' || raw == null) return false;
  return EXPRESSION_CHARS.test(String(raw).trim().replace(/^-/, ''));
}

function parsePlainNumber(raw) {
  const normalized = normalizeDecimal(raw);
  if (!/^-?\d+(\.\d+)?$/.test(normalized)) return null;
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : null;
}

function isSafeExpression(expr) {
  return /^[\d\s+\-*/().,.]+$/.test(expr);
}

export function evaluateCellExpression(raw, { integer = false, min = 0 } = {}) {
  if (raw === '' || raw == null) return '';

  const trimmed = String(raw).trim();
  if (!trimmed) return '';

  if (!looksLikeExpression(trimmed)) {
    const plain = parsePlainNumber(trimmed);
    if (plain === null) return '';
    const value = integer ? Math.round(plain) : plain;
    return Math.max(min, value);
  }

  const normalized = normalizeDecimal(trimmed);
  if (!isSafeExpression(normalized)) {
    const fallback = parseFloat(normalized);
    if (!Number.isFinite(fallback)) return '';
    const value = integer ? Math.round(fallback) : fallback;
    return Math.max(min, value);
  }

  try {
    const result = Function(`"use strict"; return (${normalized})`)();
    if (typeof result !== 'number' || !Number.isFinite(result)) return '';
    const value = integer ? Math.round(result) : result;
    return Math.max(min, value);
  } catch {
    const fallback = parseFloat(normalized);
    if (!Number.isFinite(fallback)) return '';
    const value = integer ? Math.round(fallback) : fallback;
    return Math.max(min, value);
  }
}

export function parseCellInput(raw, options) {
  if (raw === '') return '';
  if (looksLikeExpression(raw)) return raw;
  return evaluateCellExpression(raw, options);
}

export function commitCellExpression(raw, options) {
  return evaluateCellExpression(raw, options);
}

export function cellNumericValue(raw, options) {
  if (raw === '' || raw == null) return 0;
  if (typeof raw === 'number') return raw;
  const value = evaluateCellExpression(raw, options);
  return typeof value === 'number' ? value : 0;
}

export function commitGridInput(input) {
  if (!(input instanceof HTMLInputElement)) return;
  input.dispatchEvent(new FocusEvent('blur', { bubbles: true }));
}
